import Header from "../header/header";
import NavBar from "../nav/nav-bar";
import MyThingsNav from "./my-things-nav";
import { useState, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
import "../../src/task.css";
import Service from "../webservice/http";
import ClipLoader from "react-spinners/ClipLoader";
import { debounce } from "lodash";
import Pagination from "../components/pagination";

const MyThingsCollectionStrategy = () => {
  const history = useHistory();
  const services = useMemo(() => new Service(), []);

  const [tabledata, setTabledata] = useState([]);
  const [loading, setLoading] = useState(false);
  const [importing, setImporting] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [search, setSearch] = useState("");
  const [totalpage, setTotalpage] = useState([]);
  const [totalresult, setTotalresult] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const tableHeadings = [
    "Call Date",
    "Call Reference",
    "Customer",
    "Product",
    "Agent",
    "Language",
    "Reviewed",
    "Action",
  ];

  async function fetchData(fetchAll = false) {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (search) params.append("search", search);
      params.append("page", currentPage);

      const url = `api/call_verification/collection_strategy_list/?${params.toString()}`;
      const res = await services.get(url);

      const raw = res?.data || [];
      const filtered = fetchAll
        ? raw
        : raw.filter((r) => r.call_reviewed === true);

      setTabledata(filtered);

      if (fetchAll) {
        setTotalpage(res?.pagination?.page_numbers || []);
        setTotalresult(res?.pagination?.total_results || "");
      } else {
        setTotalpage([1]);
        setTotalresult(filtered.length);
      }
    } catch (err) {
      console.error("Error fetching collection strategy data:", err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData(showAll);
  }, [search, currentPage, showAll]);

  const debouncedSearch = useMemo(
    () =>
      debounce((val) => {
        setSearch(val.toLowerCase());
        setCurrentPage(1);
      }, 500),
    [],
  );

  const handleImport = () => {
    setImporting(true);
    setTimeout(() => {
      setImporting(false);
      setShowAll(true);
      setCurrentPage(1);
    }, 1500);
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="dashboard-body" style={{ paddingBottom: "20px" }}>
      <Header />
      <NavBar />
      <NotificationContainer />

      <div className="container-fluid" style={{ background: "#EEF2F5" }}>
        <div className="my-call bg-white">
          <div
            className="side-panel-with-table clearfix flex"
            style={{ display: "flex" }}
          >
            <MyThingsNav />

            <div className="call-table" style={{ marginBottom: "80px" }}>
              <div
                className="my-calls-column"
                style={{ padding: "15px 0px 0px 15px" }}
              >
                <div className="calls-top-pannel">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="pannel-heading clearfix">
                        <div className="pannel-heading-icon">
                          <i className="fa fa-tachometer" aria-hidden="true" />
                        </div>
                        <div className="pannel-heading-info">
                          <h3>Collection Strategy</h3>
                          <p>Reviewed call audit log</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex justify-end items-center m-10 gap-4">
                <input
                  onChange={(e) => debouncedSearch(e.target.value)}
                  type="text"
                  placeholder="Search by customer name"
                  style={{
                    border: "none",
                    background: "#eef2f5",
                    borderRadius: "10px",
                    width: "250px",
                    outline: "none",
                    paddingLeft: "8px",
                    height: "35px",
                  }}
                />

                <button
                  className="edit hover:text-white hover:ease-in-out hover:duration-600 text-white"
                  onClick={handleImport}
                  disabled={importing}
                  style={{
                    border: "1px solid lightgray",
                    padding: "8px 15px",
                    borderRadius: "10px",
                    cursor: importing ? "not-allowed" : "pointer",
                    opacity: importing ? 0.75 : 1,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    transition: "all 0.2s",
                  }}
                >
                  {importing ? (
                    <>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14px"
                        height="14px"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        style={{ animation: "spin 0.8s linear infinite" }}
                      >
                        <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
                      </svg>
                      Importing...
                    </>
                  ) : (
                    "Import Collection Strategy Calls"
                  )}
                </button>
                <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
              </div>

              <div className="overflow-x-scroll">
                <table className="ss" style={{ border: "1px solid grey" }}>
                  <tr id="black-line">
                    {tableHeadings.map((h) => (
                      <th
                        key={h}
                        className="left-0 bg-white border-b-2 border-gray-200 px-5 py-4 text-left text-xl font-semibold tracking-wider text-black"
                      >
                        {h}
                      </th>
                    ))}
                  </tr>

                  <tbody>
                    {loading && (
                      <tr>
                        <td
                          colSpan="8"
                          style={{ textAlign: "center", padding: "40px" }}
                        >
                          <ClipLoader color="#2056FF" size="40px" />
                        </td>
                      </tr>
                    )}

                    {!loading && tabledata.length === 0 && (
                      <tr>
                        <td
                          colSpan="8"
                          style={{
                            textAlign: "center",
                            padding: "40px",
                            color: "#999",
                          }}
                        >
                          No reviewed calls found
                        </td>
                      </tr>
                    )}

                    {!loading &&
                      tabledata.map((row, i) => (
                        <tr
                          key={i}
                          className="cursor-pointer"
                          onClick={() =>
                            history.push(
                              `/reports/detail/${row.id}/collection-strategy`,
                            )
                          }
                        >
                          <td className="border-b border-gray-200 px-5 py-2 text-xs">
                            <p className="whitespace-no-wrap text-left text-sky-700">
                              {row.call_date}
                            </p>
                          </td>

                          <td className="border-b border-gray-200 px-5 py-2 text-xs">
                            <p className="whitespace-no-wrap text-left text-sky-700">
                              {row.call_reference}
                            </p>
                          </td>

                          <td className="border-b border-gray-200 px-5 py-2 text-xs">
                            <p className="whitespace-nowrap text-left text-gray-900">
                              {row.customer_name}
                            </p>
                          </td>

                          <td className="border-b border-gray-200 px-5 py-2 text-xs">
                            <p className="whitespace-no-wrap text-left text-gray-900">
                              {row.product}
                            </p>
                          </td>

                          <td className="border-b border-gray-200 px-5 py-2 text-xs">
                            <p className="whitespace-nowrap text-left text-gray-900">
                              {row.agent}
                            </p>
                          </td>

                          <td className="border-b border-gray-200 px-5 py-2 text-xs">
                            <p className="whitespace-nowrap text-left text-gray-900">
                              {row.language}
                            </p>
                          </td>

                          <td className="border-b border-gray-200 px-5 py-2 text-xs">
                            <div className="flex justify-start items-center ml-4">
                              {row.call_reviewed ? (
                                <p
                                  className="font-bold"
                                  style={{ color: "green", fontSize: "16px" }}
                                >
                                  <i
                                    className="fa fa-check-circle"
                                    aria-hidden="true"
                                  />
                                </p>
                              ) : (
                                <p
                                  className="font-bold"
                                  style={{ color: "red", fontSize: "16px" }}
                                >
                                  <i
                                    className="fa fa-times-circle"
                                    aria-hidden="true"
                                  />
                                </p>
                              )}
                            </div>
                          </td>

                          <td
                            className="border-b border-gray-200 px-5 py-2 w-40 text-xs cursor-pointer whitespace-nowrap"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            <button
                              className="edit hover:text-white hover:ease-in-out hover:duration-600 text-white"
                              style={{
                                border: "1px solid lightgray",
                                padding: "10px 15px",
                                borderRadius: "10px",
                                cursor: "pointer",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                history.push({
                                  pathname: `/reports/detail/${row.id}/collection-strategy`,
                                  state: { isEdit: true },
                                });
                              }}
                            >
                              Edit
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>

                <Pagination
                  currentPage={currentPage}
                  totalPages={totalpage?.length}
                  onPageChange={handlePageClick}
                  totalresult={totalresult}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyThingsCollectionStrategy;
